import { TextField, Button, Paper } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import ReactToPrint from 'react-to-print';
import React, { useRef, useState } from "react";
import PrintInterviewSlip from './PrintInterviewSlip'

export default function AdmissionStatus() {
    const PrintInterviewSlipRef = useRef();
    const [refNo, setRefNo] = useState("");
    const [dob, setDob] = useState("");
    const [errors, setErrors] = useState('');
    const [statusData, setStatusData] = useState(null);
    const [isPrintEnabled, setIsPrintEnabled] = useState(false);

    const handleSearch = async (event) => {
        event.preventDefault();

        if (!refNo || !dob) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                refNo: !refNo ? 'Reference No is required' : prevErrors.refNo,
                dob: !dob ? "Date Of Birth is required" : prevErrors.dob,
            }));

            return;
        }

        try {
            const response = await fetch(`/api/getApplicantStatus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ refNo, dob }),
            });

            if (response.ok) {
                const Data = await response.json();
                setStatusData(Data);
            } else {
                setStatusData([]);
                toast.error('Error fetching filtered data');
            }
        } catch (error) {
            console.error('Error fetching filtered data:', error);
        }
    };

    return (
        <div className="min-h-screen py-10 px-4">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-2xl font-bold text-center mb-6">Check Admission Status</h1>

                <Paper className="p-6 mb-8 shadow-md">
                    <div className="grid md:grid-cols-2 gap-4">
                        <TextField label="Reference Number" fullWidth value={refNo} onChange={(e) => setRefNo(e.target.value)} error={!!errors.refNo} helperText={errors.refNo} />
                        <TextField label="Student Date of Birth" type="date" fullWidth InputLabelProps={{ shrink: true }} value={dob} onChange={(e) => setDob(e.target.value)} error={!!errors.dob} helperText={errors.dob} />
                    </div>
                    <Button variant="contained" fullWidth sx={{ mt: 3 }} onClick={handleSearch}>Check Status</Button>
                </Paper>

                {statusData && (
                    <Paper className="p-6 shadow-md">

                        <h2 className="text-lg font-semibold mb-4">
                            Applicant: {statusData.Name}
                        </h2>

                        <p className="mb-3 font-medium">
                            Current Status:{" "}
                            <span className={`px-2 py-1 rounded text-white ${statusData.Status === 0 ? "bg-gray-600" :
                                statusData.Status === 1 ? "bg-blue-600" :
                                    statusData.Status === 2 ? "bg-red-600" :
                                        "bg-green-600"
                                }`}>
                                {statusData.Status === 0 && "Under Review"}
                                {statusData.Status === 1 && "Interview Scheduled"}
                                {statusData.Status === 2 && "Not Selected"}
                                {statusData.Status === 3 && "Selected"}
                            </span>
                        </p>


                        {statusData.Status === 1 && (
                            <div className="border border-blue-600 bg-blue-50 p-4 rounded mb-4">
                                <p><strong>Interview Date:</strong> {statusData.InterviewDate}</p>
                                <p><strong>Interview Time:</strong> {statusData.InterviewTime}</p>
                                {isPrintEnabled ? (
                                    <ReactToPrint
                                        trigger={() => <Button variant="outlined" sx={{ mt: 2 }}>Print Interview Acknowledgement Slip</Button>}
                                        content={() => PrintInterviewSlipRef.current}
                                        onAfterPrint={() => setIsPrintEnabled(false)}
                                    />
                                ) : (
                                    <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setIsPrintEnabled(true)}>Print Interview Acknowledgement Slip</Button>
                                )}
                            </div>
                        )}

                        {statusData.Status === 3 && (
                            <div className="border border-green-600 bg-green-50 p-4 rounded">
                                🎉 Congratulations! The student has been selected for admission.
                            </div>
                        )}

                        {statusData.Status === 2 && (
                            <div className="border border-red-600 bg-red-50 p-4 rounded">
                                ❌ We regret to inform that the application was not selected.
                            </div>
                        )}
                    </Paper>
                )}
            </div>
            <div style={{ display: 'none' }}>
                {isPrintEnabled && (<PrintInterviewSlip ref={PrintInterviewSlipRef} data={statusData} />)}
            </div>
            <ToastContainer />
        </div>
    );
}

